module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title32"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781466818682_tp01",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_copyrightNotice",
    attrs: {
      "href": "#/e9781466818682_notice",
      "id": "Notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Notice")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER I")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Down and Out in Celephais")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c02",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER II")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Lions as Lambs")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c03",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER III")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Night-gaunts Over Dreamland")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c04",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER IV")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Man-o’-war")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c05",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER V")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("City in the Sky")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c06",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER VI")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Curator")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c07",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER VII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Kuranes’ Quest")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c08",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER VIII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("A Hasty Departure")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c09",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER IX")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Sky-Pirates of Zura")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER X")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Zura’s Tale")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c11",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XI")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Zura’s Delight")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c12",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Enter Gytherik")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c13",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XIII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Sorcerer’s Apprentice")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c14",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XIV")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Caves of Night")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c15",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XV")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Snufflers in Darkness")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c16",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XVI")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Captive of the Cave")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c17",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XVII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Running Thing")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XVIII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Escape from the Underworld")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c19",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XIX")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Aerial Armada")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c20",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XX")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Again, Gytherik")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c21",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XXI")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Under False Colors")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XXII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Kuranes: Hostage!")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c23",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XXIII")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Sub-Serannian")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c24",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XXIV")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Swords of Serannian")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c25",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XXV")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Vented!")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466818682_c26",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER XXVI")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Again, Curator")])])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781466818682_bm01",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("An Epilogue, of Sorts")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781466818682_fm02",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Look for these Tor books by Brian Lumley")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781466818682_fm03",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("THE PIRATE RAID")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781466818682_cop01",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc65d06e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466818682_toc01.vue
// module id = 63
// module chunks = 0